import { stringify } from 'qs';
import request from '../utils/request';

export async function getList(params) {
  return request(`/partner/categories?${stringify(params)}`);
}

export async function get(id, params = {}) {
  if (params) {
    return request(`/partner/categories/${id}?${stringify(params)}`);
  }
  return request(`/partner/categories/${id}`);
}

export async function create(body) {
  return request(`/partner/categories`, {
    method: 'POST',
    body,
  });
}

export async function update(id, body) {
  return request(`/partner/categories/${id}`, {
    method: 'POST',
    body,
  });
}


export async function syncKiotViet(params) {
  return request(`/product/kiotviet/sync-category`, {
    method: 'POST',
    body: {
      ...params
    }
  });
}